module.exports = __webpack_public_path__ + "static/media/chicken-pesto.c70d2744.jpg";